import { render, staticRenderFns } from "./matchingApprovalView.vue?vue&type=template&id=40b7e889&scoped=true"
import script from "./matchingApprovalView.vue?vue&type=script&lang=js"
export * from "./matchingApprovalView.vue?vue&type=script&lang=js"
import style0 from "./matchingApprovalView.vue?vue&type=style&index=0&id=40b7e889&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b7e889",
  null
  
)

export default component.exports